import { render, staticRenderFns } from "./NewsCards.vue?vue&type=template&id=1d6ce85e&scoped=true&"
import script from "./NewsCards.vue?vue&type=script&lang=js&"
export * from "./NewsCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6ce85e",
  null
  
)

export default component.exports